import { FC } from 'react';
import Health100Logo from '../../assets/health100-logo.svg';
import styles from './health100-header.module.scss';

const Health100Header: FC = () => {
  return (
    <div className={styles.headerContainer}>
      <Health100Logo className={styles.headerLogo} aria-label="Health100" />
    </div>
  );
};

export default Health100Header;
